<div class="page-title-area">
  <div class="container">
    <div class="page-title-content">
      <ul>
        <li><a routerLink="/">Inicio</a></li>
        <li><a routerLink="/configurar-administracion">Configuración Administración</a></li>
        <li><a routerLink="/rubros-listado">Listado de Rubros</a></li>
        <li>Modificar Rubro</li>
      </ul>
      <h2>Modificar Rubro</h2>
      <h4 *ngIf="catalogo">{{catalogo.concepto}}</h4>
    </div>
  </div>
</div>

<div class="andorra-apply-content ptb-70 animate__animated animate__fadeIn">
  <div class="container">
    <div class="row mx-auto">
      <div class="col-lg-12 col-md-12">
        <div class="apply-form">
          <form [formGroup]="form" (ngSubmit)="updateRubro()">

            <div class="row">
              <div class="col-lg-12">

                <div class="form-group">
                  <mat-form-field class="example-full-width" appearance="fill" [style.width.%]=100>
                    <mat-label>Rubro</mat-label>
                    <input formControlName="rubro" matInput placeholder="Rubro" 
                           [class.is-invalid]="rubroNoValido" autocomplete="off">
                    <mat-error *ngIf="rubroNoValido">Ingrese un rubro</mat-error>
                  </mat-form-field>
                </div>

                <div class="form-group">
                  <mat-slide-toggle formControlName="activo">Activo</mat-slide-toggle>
                </div>

                <!-- Sección para seleccionar especialidades -->
                <div class="form-group" *ngIf="especialidadesOrdenadas.length > 0">
                  <h3>Asignar a especialidades</h3>
                  <p>Seleccione las especialidades a las que desea asignar este rubro:</p>
                  
                  <div class="especialidades-container" style="max-height: 300px; overflow-y: auto; border: 1px solid #eee; padding: 15px;">
                    <div class="row">
                      <div *ngFor="let especialidad of especialidadesOrdenadas" class="col-lg-4 col-md-6 col-sm-6 especialidad-item" style="margin-bottom: 15px;">
                        <mat-checkbox (change)="onEspecialidadSeleccionada($event, especialidad._id!)" 
                                     [checked]="esEspecialidadDeEsteRubro(especialidad)">
                          {{ especialidad.concepto }}
                          <span *ngIf="getNombreRubro(especialidad)" style="font-size: 0.9em; color: #666;">
                            (Rubro actual: {{ getNombreRubro(especialidad) }})
                          </span>
                          <span *ngIf="!getNombreRubro(especialidad)" style="font-size: 0.9em; color: #666;">
                            (Sin rubro asignado)
                          </span>
                        </mat-checkbox>
                      </div>
                    </div>
                  </div>
                  
                  <small *ngIf="especialidadesSeleccionadas.size > 0" style="color: #666; display: block; margin-top: 10px;">
                    {{ especialidadesSeleccionadas.size }} especialidad(es) seleccionada(s)
                  </small>
                  <small *ngIf="especialidadesSeleccionadas.size === 0" style="color: #999; display: block; margin-top: 10px;">
                    Ninguna especialidad seleccionada
                  </small>
                </div>

              </div>

              <div class="row">
                <div class="col-lg-4 col-md-4">
                  <button type="button" routerLink="/rubros-listado" class="btn btn-warning">Cancelar</button>
                </div>

                <div class="col-lg-4 col-md-4">
                  <button [disabled]="!form.valid" type="submit" class="btn btn-primary">Guardar</button>
                </div>

              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>